import { useIntl } from 'react-intl'
import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import PriceRowLuxPlusNonMemberPrice from 'LuxKit/PricePoints/LuxPlus/PriceRowLuxPlusNonMemberPrice'
import PriceRowLuxPlusPrice from 'LuxKit/PricePoints/LuxPlus/PriceRowLuxPlusPrice'
import { getIsEnabledLuxPlusDiscountedExperiences } from 'luxPlus/selectors/featureToggle'
import { connect } from 'react-redux'
import PriceRowValueDiscountWithCaption from 'LuxKit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import Group from 'components/utils/Group'
import { getExperienceTileSaleUnit } from 'lib/experiences/getExperienceTileSaleUnit'

interface MappedProps {
  isLuxPlusEnabled: boolean
}

interface Props extends MappedProps {
  totalPrice?: number
  totalMemberPrice?: number
  totalGrossPrice?: number
  discountPercentage?: number
  isFromPrice: boolean
  showFromCaption?: boolean
  ticketUnitLabel: string
  size?: 'S' | 'L' | 'M'
  nonMemberPriceSize?: 'L' | 'M'
  discountMemberPercentage?: number
}

function ExperienceTilePrices(props: Props) {
  const {
    totalPrice,
    totalMemberPrice,
    totalGrossPrice,
    discountPercentage,
    isFromPrice,
    showFromCaption = true,
    ticketUnitLabel,
    isLuxPlusEnabled,
    size = 'S',
    nonMemberPriceSize = 'M',
    discountMemberPercentage,
  } = props
  const intl = useIntl()

  const fromCaption = intl.formatMessage({
    id: 'EAQ_GV7KRwveLWB08EmL',
    defaultMessage: 'From',
    description: 'Price caption prefix on the experience tile prices',
  })
  const totalLabel = intl.formatMessage({
    id: 'whMf0sOzbI-AWwhc2zR7',
    defaultMessage: 'total',
    description: 'Sale unit label for total price on experience tile prices',
  })
  const saleUnit = getExperienceTileSaleUnit({ isFromPrice, ticketUnitLabel, totalLabel })

  if (isLuxPlusEnabled && totalMemberPrice) {
    return (
      <>
        {isFromPrice && showFromCaption && <PriceRowPriceCaption>{fromCaption}</PriceRowPriceCaption>}
        <PriceRowLuxPlusPrice
          logoPlacement="trailing"
          size={size}
          memberPrice={totalMemberPrice}
          saleUnit={saleUnit}
        />
        {!!totalPrice && (
          <PriceRowLuxPlusNonMemberPrice
            nonMemberPrice={totalPrice}
          />
        )}
        {!!totalGrossPrice && <PriceRowValueDiscountWithCaption
          originalValue={totalGrossPrice}
          size={nonMemberPriceSize}
          discountPercentage={discountMemberPercentage}
          discountType={isFromPrice ? 'estimate' : 'exact'}
        />}
      </>
    )
  }

  if (!totalPrice) return null

  const shouldShowValueDiscount = !!totalGrossPrice && !!discountPercentage

  return (
    <>
      {isFromPrice && showFromCaption && <PriceRowPriceCaption>{fromCaption}</PriceRowPriceCaption>}
      <Group direction="horizontal" gap={8} wrap="wrap" verticalAlign="baseline">
        <PriceRowPrice
          size={size}
          price={totalPrice}
          saleUnit={saleUnit}
          wrap="word-wrap"
        />
        {shouldShowValueDiscount && <PriceRowValueDiscountWithCaption
          originalValue={totalGrossPrice}
          size={nonMemberPriceSize}
          discountPercentage={discountPercentage}
          discountType={isFromPrice ? 'estimate' : 'exact'}
        />}
      </Group>
    </>
  )
}

function mapStateToProps(state: App.State) {
  return {
    isLuxPlusEnabled: getIsEnabledLuxPlusDiscountedExperiences(state),
  }
}

export default connect(mapStateToProps)(ExperienceTilePrices)
